// redux/habits/habits.reducer.js
import habitActionTypes from "./habits.types";

const INITIAL_STATE = {
  habits: [],
};

const habitReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case habitActionTypes.SET_HABITS:
      return {
        ...state,
        habits: action.payload,
      };
    default:
      return state;
  }
};

export default habitReducer;
